module.exports = __webpack_public_path__ + "static/media/03.68b87df8.jpg";